import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

export interface IPublicationMessages {
  index: string[],
  indexBy?: {
    'landing': string[];
    'welcome': string[];
    'noMore': string[];
    'screenOut': string[];
    any: string[];
  }
  data: {
    [key: string]: {
      id: string;
      title: string;
      type: 'landing' | 'welcome' | 'noMore' | 'screenOut' | 'any';
      content: Record<string, string>;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class PublicationMessagesService {

  public messages$: BehaviorSubject<IPublicationMessages> = new BehaviorSubject<IPublicationMessages>({
    index: [],
    data: {}
  })

  constructor() {
  }

  clickLandingMessage(messageType = 'landing', uuid: string) {

    console.log(uuid);

    const _value: IPublicationMessages = {
      ...this.messages$.value,
      index: this.messages$.value.index.filter(e => e !== uuid),
      indexBy: {
        ...this.messages$.value.indexBy,
        [messageType]: this.messages$.value.indexBy[messageType].filter(e => e !== uuid),
      }
    };

    console.log(_value);
    this.messages$.next(_value);

  }


  set(publicationMessages: any[] = []) {
    if (!this.messages$.value.index.length){
      const pm: IPublicationMessages = {
        index: [],
        indexBy: {
          landing: [],
          any: [],
          noMore: [],
          screenOut: [],
          welcome: [],
        },
        data: {},
      }

      publicationMessages.forEach((aMessage: {
        id: string,
        title: string,
        content: Record<string, string>,
        default: {
          welcome: boolean,
          noMore: boolean,
          screenOut: boolean,
          landing: boolean,
        }
      }) => {

        let type: 'landing' | 'welcome' | 'noMore' | 'screenOut' | 'any' = 'any';
        pm.index.push(aMessage.id);

        if (aMessage.default.screenOut) {
          pm.indexBy.screenOut.push(aMessage.id)
          type = 'screenOut';
        }else if (aMessage.default.landing) {
          if (!localStorage.getItem(aMessage.id)) {
            pm.indexBy.landing.push(aMessage.id);
            type = 'landing';
          }
        } else if (aMessage.default.welcome) {
          if (!localStorage.getItem(aMessage.id)) {
            pm.indexBy.welcome.push(aMessage.id);
            type = 'welcome';
          }
        } else if (aMessage.default.noMore) {
          pm.indexBy.noMore.push(aMessage.id)
          type = 'noMore';
        } else {
          pm.indexBy.any.push(aMessage.id)
        }

        pm.data[aMessage.id] = {
          id: aMessage.id,
          title: aMessage.title,
          content: aMessage.content,
          type: type,
        }
      });
      this.messages$.next(pm);
    }
  }

}

